/**
 * 48 点データの表示単位 (AC-S4D-037 / AC-S4D-038)。
 *
 * 永続値は常に kWh/30min 固定で、単位切替は表示だけに影響する。
 * 換算は kW = kWh/30min × 2 (30 分あたりの電力量を平均電力に読み替える)。
 *
 * 表示単位のまま保存すると kW モードの編集値が黙って倍で永続化されるため、
 * 表示 ↔ 保存の境界では必ず本モジュールの変換を通すこと
 * (design/supply/48data.html も同じ落とし穴を注記している)。
 */

export type DisplayUnit = 'kW' | 'kWh30min'

/** AC-S4D-037: 既定は kWh/30min */
export const DEFAULT_DISPLAY_UNIT: DisplayUnit = 'kWh30min'

/** 保存単位 (kWh/30min) の値を表示単位へ換算する */
export function toDisplayValue(
  stored: number | null,
  unit: DisplayUnit,
): number | null {
  if (stored === null) return null
  return unit === 'kW' ? stored * 2 : stored
}

/**
 * 表示単位の値を保存単位 (kWh/30min) へ戻す。
 *
 * kW の奇数は 0.5 単位になるが、打鍵の途中経過 (「102」の「1」) を壊さないため
 * ここでは弾かない。保存の直前に checkSavableStoredValue が確定値を見て拒否する
 * (AC-S4D-028)。= editState には一時的に非整数が入りうる。
 */
export function toStoredValue(display: number, unit: DisplayUnit): number {
  return unit === 'kW' ? display / 2 : display
}

/** 単位ラベルの i18n キー (AC-S4D-038: 表・グラフの軸ラベルに明示する) */
export function displayUnitLabelKey(unit: DisplayUnit): string {
  return unit === 'kW'
    ? 'page:supply48Data.unit.kW'
    : 'page:supply48Data.unit.kWh30min'
}
